export default {
  Username: '  Nombre de usuario',
  Cedula: 'Cedula:',
  LastModification: 'Última modificación:',
  ChangePassword: 'Cambiar contraseña',
  ChangePrimaryEmail: 'Cambiar Correo Principal',
  modifypassword: 'Modificar contraseña',
  Currentpassword: 'Contraseña actual',
  Password: 'Contraseña',
  NewPassword: 'Nueva Contraseña',
  Repeatnewpassword: 'Repetir nueva contraseña',
  CONFIRM: 'CONFIRMAR',
  Contactinformation: 'Datos de contacto',
  Modify_email: 'Modificar email',
  Current_email: ' Email actual',
  New_email: ' Nuevo email',
  Repeat_new_email: '  Repetir nuevo email',
  Address: 'Dirección',
  Province: 'Provincia',
  Municipality: 'Municipio',
  Sector: 'Sector',
  Mobile_phone: 'Teléfono móvil',
  Residential_telephone: '    Teléfono residencial',
  Work_phone: '  Teléfono laboral',
  Secondary_email: '  Correo electrónico secundario',
  Notification_Preferences: '  Preferencias de Notificación',
  Email: 'Correo Electrónico',
  My_settings: 'Mi configuración',
  save: 'Guardar'



}